module.exports = __webpack_public_path__ + "static/media/Lucille Bresette.fb6b909a.JPG";